module.exports = __webpack_public_path__ + "img/checkbox-area.a3981abe.svg";